// extracted by mini-css-extract-plugin
module.exports = {"gap-styles":"useCmsGapStyles_gap-styles__xsGiW"};